import { isManagerRole, isReadOnlyManagerRole } from 'utils/managerRoles';
import currentUserRole from 'utils/currentUserRole';
import { FEATURE_IDS, isFeatureEnabled } from 'utils/supportedFeatures';

/**
 * First allowed Administration child for the signed-in role.
 * Unknown roles skip Users so a missing cookie cannot bounce into a hidden page.
 */
export default function administrationDefaultPath(orgName) {
  const role = currentUserRole();
  const knownNonManager = Boolean(role) && !isManagerRole(role);
  const canSeeReports = Boolean(role) && !isReadOnlyManagerRole(role) && isFeatureEnabled(FEATURE_IDS.REPORTS);

  if (orgName) {
    const base = `/organization/${encodeURIComponent(orgName)}/administration`;
    if (knownNonManager) return `${base}/users`;
    if (canSeeReports) return `${base}/reports`;
    return `${base}/policy`;
  }

  if (knownNonManager) return '/mspHome/administration/users';
  if (canSeeReports) return '/mspHome/administration/reports';
  return '/mspHome/administration/manage-subscriptions';
}
